module.exports = __webpack_public_path__ + "static/img/bg_title@2x.1167250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktbPopularize/bg_title@2x.png
// module id = Rzo0
// module chunks = 69